import React, { useState } from "react";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import { publicApi } from "../lib/api";
import { trackEvent } from "../lib/analytics";
import { toast } from "sonner";

export default function PodcastSubscribeForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await publicApi.subscribe({ name, email });
      trackEvent("sign_up", { method: "podcast_updates" }, "podcast_subscribe");
      setDone(true);
      toast.success("You're on the list — thanks for subscribing!");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div data-testid="subscribe-success" className="flex items-center justify-center gap-2 text-green-400 font-semibold">
        <CheckCircle2 size={20} /> You're subscribed — new episodes are coming your way.
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="podcast-subscribe-form" className="flex flex-col sm:flex-row items-stretch gap-3 max-w-xl mx-auto">
      <input
        data-testid="subscribe-name-input"
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Your name (optional)"
        className="flex-1 rounded-full bg-white/10 border border-white/15 px-5 py-3 text-white placeholder:text-slate-400 focus:outline-none focus:border-orange"
      />
      <input
        data-testid="subscribe-email-input"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email address"
        className="flex-1 rounded-full bg-white/10 border border-white/15 px-5 py-3 text-white placeholder:text-slate-400 focus:outline-none focus:border-orange"
      />
      <button
        data-testid="subscribe-submit-btn"
        type="submit"
        disabled={loading}
        className="inline-flex items-center justify-center gap-2 bg-orange hover:bg-orange-dark disabled:opacity-60 text-white font-bold px-6 py-3 rounded-full transition-colors whitespace-nowrap"
      >
        {loading ? <Loader2 size={18} className="animate-spin" /> : <Mail size={18} />} Subscribe
      </button>
    </form>
  );
}
